export const GET_TRENDING_BLOGS = 'GET_TRENDING_BLOGS';
export const SET_TRENDING_BLOGS = 'SET_TRENDING_BLOGS';
export const ERROR_TRENDING_BLOGS = 'ERROR_TRENDING_BLOGS';

export const GENERATE_AI_BLOG = 'GENERATE_AI_BLOG';
export const SET_GENERATE_AI_BLOG = 'SET_GENERATE_AI_BLOG';
export const ERROR_GENERATE_AI_BLOG = 'ERROR_GENERATE_AI_BLOG';
export const GET_AI_BLOG = 'GET_AI_BLOG';
